import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import Modal from 'react-modal';
import {
  fetchAreas,
  fetchCustomers,
  fetchDistricts,
  fetchPaymentMethods,
  fetchLogisticLines,
  searchProducts,
  fetchPaymentStatus,
  updateOrder,
} from '../services/ordersService';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';
import { showSuccessToast } from '../../../utils/toastHelper';
import { AsyncPaginate } from 'react-select-async-paginate';
import useDynamicInputWidth from '../hooks/useDynamicInputWidth';
import { trimDecimalZero } from '../../../utils/commonUtils';

const EditCateringModal = ({
  setEditCateringModal,
  actionType,
  selectedOrdersEdit,
  onSuccess,
}) => {
  const { t } = useTranslation('Order');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [tmrCheck, setTmrCheck] = useState(false);
  // const [searchQuery, setSearchQuery] = useState('');
  // const [loading, setLoading] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalCustomers, setTotalCustomers] = useState(0);
  const [loader, setLoader] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [poNumber, setPoNumber] = useState('');
  // const [deliveryAddress, setDeliveryAddress] = useState('');

  // const [area, setArea] = useState('');
  // const [district, setDistrict] = useState('');

  // const [contactPerson, setContactPerson] = useState('');
  // const [contactPhone, setContactPhone] = useState('');
  // const [paymentMethod, setPaymentMethod] = useState('');

  const [logisticLineManual, setManualLogisticLine] = useState({
    name: '',
    id: '',
  });

  const [paymentStatus, setPaymentStatus] = useState({ name: '', id: '' });

  const [paymentDate, setPaymentDate] = useState('');
  const [orderRemark, setOrderRemark] = useState('');

  const [customers, setCustomers] = useState([]);
  const [productInfo, setProductsInfo] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  // const [productSearchQuery, setProductSearchQuery] = useState('');
  // const [productLoading, setProductLoading] = useState(false);
  // const [productCurrentPage, setProductCurrentPage] = useState(1);
  // const [totalProducts, setTotalProducts] = useState(0);
  const [products, setProducts] = useState([]);
  const dynamicSizeInputRefs = useRef([]);
  const specificationInputRefs = useRef([]);
  const productRemarkInputRefs = useRef([]);
  useDynamicInputWidth(dynamicSizeInputRefs, products);
  useDynamicInputWidth(
    specificationInputRefs,
    products,
    (item) => item.specification
  );
  useDynamicInputWidth(
    productRemarkInputRefs,
    products,
    (item) => item.productRemark
  );

  useEffect(() => {
    if (selectedOrdersEdit) {
      // Autofill the fields based on selectedOrdersEdit
      const deliveryDate = selectedOrdersEdit.delivery_date
        ? selectedOrdersEdit.delivery_date.split('/').join('-')
        : '';
      setDeliveryDate(deliveryDate);
      setReferenceNumber(selectedOrdersEdit.reference_number || '');
      setPoNumber(selectedOrdersEdit.po_number || '');

      setSelectedCustomer({
        ...selectedOrdersEdit?.customer,
        area: selectedOrdersEdit.area,
        district: selectedOrdersEdit.district,
        payment_method: selectedOrdersEdit.payment_method,
      });

      // Autofill logisticLineManual
      setManualLogisticLine({
        name: selectedOrdersEdit.logistic_line?.name || '',
        id: selectedOrdersEdit.logistic_line?.id || '',
      });

      setPaymentStatus({
        name: selectedOrdersEdit.payment_status?.name || '',
        id: selectedOrdersEdit.payment_status_id || '',
      });

      // Convert payment_date to YYYY-MM-DD format
      const paymentDate = selectedOrdersEdit.payment_date
        ? selectedOrdersEdit.payment_date.split('/').join('-')
        : '';
      setPaymentDate(paymentDate);

      setOrderRemark(selectedOrdersEdit.remark || '');

      // Autofill products
      if (
        selectedOrdersEdit.products &&
        selectedOrdersEdit.products.length > 0
      ) {
        const formattedProducts = selectedOrdersEdit.products.map(
          (product) => ({
            productCode: product.product_code || '',
            productName: product.product_name || '',
            origin: product.product?.origin?.name || '',
            specification: product?.specification_value
              ? product.specification_value +
                ' ' +
                (product?.specification_unit?.name ?? '') +
                ' / ' +
                (product?.product_value ?? '') +
                ' ' +
                (product?.product_unit?.name ?? '')
              : product?.product_value
                ? product.product_value +
                  ' ' +
                  (product?.product_unit?.name ?? '')
                : '',

            quantity: product.quantity || '',
            // unitPrice: product.unit_price || '',
            productRemark: product.remarks || '',
            processLocation: product.process_location?.name || '',
            productId: product.product_id || '',
            isEditing: false, // Set to false initially
          })
        );
        setProducts(formattedProducts);
      }
    }
  }, [selectedOrdersEdit]);

  useEffect(() => {
    if (selectedOrdersEdit && selectedOrdersEdit.customer) {
      const customerExists = customers.some(
        (customer) => customer.id === selectedOrdersEdit.customer.id
      );
      if (!customerExists) {
        setCustomers((prevCustomers) => [
          ...prevCustomers,
          selectedOrdersEdit.customer,
        ]);
      }
    }
  }, [selectedOrdersEdit, customers]);

  const handlePaymentStatusChange = (e) => {
    const selectedPaymentStatus = paymentOptions.find(
      (area) => area.name === e.target.value
    );
    setPaymentStatus({
      name: e.target.value,
      id: selectedPaymentStatus?.id || '',
    });
  };

  const handleLogisticLineChange = (e) => {
    const selectedLogisticLine = logisticLineOptions.find(
      (line) => line.name === e.target.value
    );
    setManualLogisticLine({
      name: e.target.value,
      id: selectedLogisticLine?.id || '',
    });
  };

  const toggleEdit = (index) => {
    const updatedProducts = [...products];
    updatedProducts[index].isEditing = !updatedProducts[index].isEditing;
    setProducts(updatedProducts);
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        productCode: '',
        productName: '',
        origin: '',
        specification: '',
        quantity: '',
        // unitPrice: '',
        productRemark: '',
        processLocation: '',
        productId: '',
        isEditing: true,
      },
    ]);
  };

  useEffect(() => {
    // getCustomers();
    // getCustomerCodes();
    getPaymentStatus();
    getLogisticLine();
  }, []);
  const [paymentOptions, setPaymentOption] = useState([]);

  const getPaymentStatus = async () => {
    try {
      const response = await fetchPaymentStatus();
      setPaymentOption(response?.payment_statuses || []);
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };
  const customersLoadOptions =
    (labelType = 'code') =>
    async (inputValue, loadedOptions, { page }) => {
      const per_page = 50;
      const query = {
        page,
        per_page,
        search: inputValue,
        category: 'catering',
      };

      const customersResponse = await fetchCustomers(query);

      setCustomers((prev) => [
        ...prev,
        ...(customersResponse?.customers || []),
      ]);

      const newOptions = customersResponse.customers?.map((customer) => ({
        value: customer.id,
        label: labelType === 'code' ? `${customer.code}` : `${customer.name}`,
      }));

      return {
        options: newOptions,
        hasMore:
          customersResponse.pagination.current_page <
          customersResponse.pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    };
  const handleCustomerCodeChange = (selectedOption) => {
    if (selectedOption) {
      // const selectedCustomer = selectedOption.customerObject; // Access the full customer object
      const selectedCustomerElement = customers.find(
        (customer) => customer.id === selectedOption.value
      );
      if (selectedCustomerElement) {
        setSelectedCustomer(selectedCustomerElement);
      }
      // setDeliveryAddress(selectedCustomer.delivery_address);
      // setArea(selectedCustomer.area?.name);
      // setDistrict(selectedCustomer.district?.name);
      // setContactPerson(selectedCustomer.contact_name);
      // setContactPhone(selectedCustomer.contact_phone);
      // setPaymentMethod(selectedCustomer.payment_method?.name);
    } else {
      // Clear all fields if no option is selected
      setSelectedCustomer({});
      // setDeliveryAddress('');
      // setArea('');
      // setDistrict('');
      // setContactPerson('');
      // setContactPhone('');
      // setPaymentMethod('');
    }
  };

  // const customerCodeOptions = customers.map((customer) => ({
  //   value: customer.code, // Use customer code as the value
  //   label: `${customer.code}`, // Custom label
  //   customerObject: customer, // Optional: Include the full customer object
  // }));
  // const customerNameOptions = customers.map((customer) => ({
  //   value: customer.code, // Use customer code as the value
  //   label: `${customer.name}`, // Custom label
  //   customerObject: customer, // Optional: Include the full customer object
  // }));

  const handleDropdownChange = (field, value) => {};

  // const getCustomers = async (page = 1, search = '') => {
  //   try {
  //     const query = {
  //       category: 'catering',
  //       page,
  //       per_page: 20, // Number of items per page
  //       search,
  //     };
  //     const response = await fetchCustomers(query);
  //     setCustomers((prevCustomers) =>
  //       page === 1
  //         ? response.customers
  //         : [...prevCustomers, ...response.customers]
  //     );
  //     setTotalCustomers(response.total_count); // Assuming the API returns total count
  //   } catch (error) {
  //     console.error('Error fetching customers:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleInputChange = (newValue) => {
  //   setSearchQuery(newValue);
  //   setCurrentPage(1); // Reset to the first page for new search
  //   getCustomers(1, newValue);
  // };
  // const handleMenuScrollToBottom = () => {
  //   if (!loading && customers.length < totalCustomers) {
  //     const nextPage = currentPage + 1;
  //     setLoading(true);
  //     getCustomers(nextPage, searchQuery).then(() => {
  //       setCurrentPage(nextPage);
  //     });
  //   }
  // };

  const [logisticLineOptions, setLogistics] = useState([]);

  const getLogisticLine = async () => {
    try {
      const response = await fetchLogisticLines();
      setLogistics(response?.logistic_lines || []);
    } catch (error) {
      console.error('Error fetching logistic lines:', error);
    }
  };

  const handleProductChange = async (index, eventOrSelectedOptions) => {
    const updatedProducts = [...products];

    // Check if the eventOrSelectedOptions is an event (for quantity, productRemark, etc.)
    if (eventOrSelectedOptions && eventOrSelectedOptions.target) {
      let { name, value } = eventOrSelectedOptions.target;
      if (name === 'quantity') {
        value = trimDecimalZero(value);
      }
      // Update the specific field in the product
      updatedProducts[index] = {
        ...updatedProducts[index],
        [name]: value,
      };
    } else {
      // Handle product selection (react-select)
      const selectedOptions = eventOrSelectedOptions;
      const selectedId = selectedOptions?.id || null;
      if (selectedId) {
        try {
          const matchedProduct = productInfo.find(
            (product) => product.id === selectedId
          );
          console.log('selecte product', matchedProduct);
          console.log('selecte eventOrSelectedOptions', eventOrSelectedOptions);

          // Update the product state with the fetched details
          updatedProducts[index] = {
            ...updatedProducts[index],
            productId: matchedProduct?.id,
            productName: matchedProduct?.name || '',
            productCode: matchedProduct?.code || '',
            specification: matchedProduct?.specification || '',
            origin: matchedProduct?.origin?.name || '',
            processLocation: matchedProduct?.process_location?.name || '',
          };
        } catch (error) {
          console.error('Error fetching product details:', error);
        }
      } else {
        // If cleared, reset product details to null or empty values
        updatedProducts[index] = {
          ...updatedProducts[index],
          productId: null,
          productName: '',
          productCode: '',
          specification: '',
          origin: '',
          processLocation: '',
        };
      }
    }

    // Update the products state
    setProducts(updatedProducts);
  };
  // const fetchProductDetails = async (page = 1, search = '') => {
  //   try {
  //     const query = { page, per_page: 20, search, LOB: 1 };
  //     const response = await searchProducts(query);
  //     setProductsInfo((prevProducts) =>
  //       page === 1 ? response.products : [...prevProducts, ...response.products]
  //     );
  //     setTotalProducts(response.total_count); // Assuming the API returns total count
  //   } catch (error) {
  //     console.error('Error fetching product details:', error);
  //   } finally {
  //     setProductLoading(false);
  //   }
  // };
  // const handleProductSearchInputChange = (newValue) => {
  //   setProductSearchQuery(newValue);
  //   setProductCurrentPage(1); // Reset to the first page for new search
  //   fetchProductDetails(1, newValue);
  // };

  // const handleProductMenuScrollToBottom = () => {
  //   if (!productLoading && productInfo.length < totalProducts) {
  //     const nextPage = productCurrentPage + 1;
  //     setProductLoading(true);
  //     fetchProductDetails(nextPage, productSearchQuery).then(() => {
  //       setProductCurrentPage(nextPage);
  //     });
  //   }
  // };

  const productsLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const per_page = 50;
    const query = { page, per_page, search: inputValue, LOB: 1 };

    const productsResponse = await searchProducts(query);
    // setProductsInfo(productsResponse?.products || []);
    setProductsInfo((prev) => [...prev, ...(productsResponse?.products || [])]);

    const newOptions = productsResponse.products?.map((product) => ({
      // value: product.id,
      // label: `${product.name} | (${product.code})`,
      // productObject: product,
      value: product.code || product.name,
      label: `${product.code} - ${product.name}`,
      id: product.id,
    }));
    return {
      options: newOptions,
      hasMore:
        productsResponse.pagination.current_page <
        productsResponse.pagination.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  // const getCustomerCodes = async () => {
  //   try {
  //     const page = 1;
  //     const per_page = 100;
  //     const search = '';
  //     const query = { page, per_page, search };
  //     const response = await fetchProductDetails({ query });
  //   } catch (error) {
  //     console.error('Error fetching payment methods:', error);
  //   }
  // };
  const [deletedProductIds, setDeletedProductIds] = useState([]); // New state for deleted product IDs

  const removeProduct = (index) => {
    const productToRemove = products[index];
    if (productToRemove.productId) {
      setDeletedProductIds((prevIds) => [
        ...prevIds,
        productToRemove.productId,
      ]);
    }
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };
  const saveSubmit = async () => {
    if (!tmrCheck) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinutes = now.getMinutes();

      // Check if the delivery date is tomorrow
      const deliveryDateObj = new Date(deliveryDate);
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Check if delivery date is tomorrow and time is after 4 PM
      if (
        deliveryDateObj.toDateString() === tomorrow.toDateString() &&
        (currentHour > 16 || (currentHour === 16 && currentMinutes > 0))
      ) {
        // Open the confirmation modal
        setConfirmationModal(true);
        return; // Stop further execution
      }
    }

    setLoader(true); // Start loading

    // Map over the products array to extract only the required fields
    const simplifiedProducts = products.map((product) => ({
      product_id: product?.productId, // Assuming productCode is the selected product ID
      quantity: product?.quantity,
      // unit_price: product?.unitPrice,
      remarks: product?.productRemark,
      discount: product?.discount,
    }));

    const data = {
      type: 'CATERING',
      new_info: false,
      // customer_id: selectedCustomerCode || selectedOrdersEdit?.customer_id,
      customer_id: selectedCustomer?.id,
      payment_status_id: paymentStatus?.id,
      delivery_date: deliveryDate,
      payment_date: paymentDate,
      remark: orderRemark,
      po_number: poNumber,
      logistic_line_id: logisticLineManual.id,
      reference_number: referenceNumber,
      products: simplifiedProducts,
      deleted_product_ids: deletedProductIds, // Include deleted product IDs
    };
    const response = await updateOrder(data, selectedOrdersEdit?.id);
    if (response.success) {
      onSuccess();
      setLoader(false); // Stop loading
      setEditCateringModal(false);
      showSuccessToast(response.message);
    } else {
      setLoader(false);
    }
  };

  const handleModalSuccess = () => {
    setConfirmationModal(false);
    setTmrCheck(true);
    saveSubmit();
  };
  return (
    <div className="modal fade show d-block" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('EDITCATERINGORDER')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setEditCateringModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="input-main">
              <div className="row">
                {/* Delivery Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      name="deliveryDate"
                      value={deliveryDate}
                      onChange={(e) => setDeliveryDate(e.target.value)}
                    />
                    <label>{t('DELIVERYDATE')}</label>
                  </div>
                </div>

                {/* Reference Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                    <label>{t('REFERENCENUMBER')}</label>
                  </div>
                </div>

                {/* PO Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                    />
                    <label>{t('PONUMBER')}</label>
                  </div>
                </div>

                {/** customer code */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    {/* <Select
                      className="w-100"
                      value={customerCodeOptions.find(
                        (option) => option.value === selectedCustomer?.code
                      )}
                      onChange={handleCustomerCodeChange}
                      options={customerCodeOptions}
                      placeholder={t('SEARCHANDSELECTCUSTOMER')}
                      isSearchable
                      onInputChange={handleInputChange}
                      onMenuScrollToBottom={handleMenuScrollToBottom}
                      isLoading={loading}
                      loadingMessage={() => 'Loading more...'}
                      isClearable
                    /> */}
                    <AsyncPaginate
                      className="w-100"
                      value={
                        selectedCustomer?.id
                          ? {
                              value: selectedCustomer.id,
                              label: selectedCustomer.code,
                            }
                          : null
                      }
                      loadOptions={customersLoadOptions('code')}
                      onChange={handleCustomerCodeChange}
                      placeholder={t('SEARCHANDSELECTCUSTOMER')}
                      isClearable
                      additional={{
                        page: 1,
                      }}
                    />
                  </div>
                </div>

                {/* Customer Name */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    {/* <Select
                      className="w-100"
                      value={customerNameOptions.find(
                        (option) => option.value === selectedCustomer?.code
                      )}
                      onChange={handleCustomerCodeChange}
                      options={customerNameOptions}
                      placeholder={t('SELECTCUSTOMERNAME')}
                      isSearchable
                      onInputChange={handleInputChange}
                      onMenuScrollToBottom={handleMenuScrollToBottom}
                      isLoading={loading}
                      loadingMessage={() => 'Loading more...'}
                      isClearable
                    /> */}
                    <AsyncPaginate
                      className="w-100"
                      value={
                        selectedCustomer?.id
                          ? {
                              value: selectedCustomer.id,
                              label: selectedCustomer.name,
                            }
                          : null
                      }
                      loadOptions={customersLoadOptions('name')}
                      onChange={handleCustomerCodeChange}
                      placeholder={t('SEARCHANDSELECTCUSTOMER')}
                      isClearable
                      additional={{
                        page: 1,
                      }}
                    />
                  </div>
                </div>
                {/* Customer Name */}

                {/** Delivery Address */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.delivery_address}
                      onChange={(e) =>
                        handleDropdownChange('deliveryAddress', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTDELIVERYADDRESS')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.delivery_address}
                        >
                          {customer.delivery_address}
                        </option>
                      ))}
                    </select>
                    <label>{t('DELIVERYADDRESS')}</label>
                  </div>
                  {/* <button onClick={() => toggleInput(true)}>Add New</button> */}
                </div>

                {/** Area */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.area?.name}
                      onChange={(e) =>
                        handleDropdownChange('area', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTAREA')}</option>
                      {customers.map((customer) => (
                        <option key={customer.id} value={customer.area?.name}>
                          {customer.area?.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('AREA')}</label>
                  </div>
                </div>

                {/** District */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.district?.name}
                      onChange={(e) =>
                        handleDropdownChange('district', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTDISTRICT')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.district?.name}
                        >
                          {customer.district?.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('DISTRICT')}</label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={logisticLineManual.name}
                      onChange={handleLogisticLineChange}
                    >
                      <option value="">{t('SELECTLOGISTICLINE')}</option>
                      {logisticLineOptions.map((line) => (
                        <option key={line.id} value={line.name}>
                          {line.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('LOGISTICLINE')}</label>
                  </div>
                </div>

                {/** Contact Person */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.contact_name}
                      onChange={(e) =>
                        handleDropdownChange('contactPerson', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTCONTACTPERSON')}</option>
                      {customers.map((customer) => (
                        <option key={customer.id} value={customer.contact_name}>
                          {customer.contact_name}
                        </option>
                      ))}
                    </select>
                    <label>{t('CONTACTPERSON')}</label>
                  </div>
                </div>

                {/** Contact Phone */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.contact_phone}
                      onChange={(e) =>
                        handleDropdownChange('contactPhone', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTCONTACTPHONE')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.contact_phone}
                        >
                          {customer.contact_phone}
                        </option>
                      ))}
                    </select>
                    <label>{t('CONTACTPHONE')}</label>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.payment_method?.name}
                      onChange={(e) =>
                        handleDropdownChange('paymentMethod', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTPAYMENTMETHOD')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.payment_method?.name}
                        >
                          {customer.payment_method?.name}
                        </option>
                      ))}
                      {/* Populate options dynamically */}
                    </select>
                    <label>{t('PAYMENTMETHOD')}</label>
                  </div>
                </div>

                {/* Payment Status */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={paymentStatus.name}
                      onChange={handlePaymentStatusChange}
                    >
                      <option value="">{t('SELECTPAYMENTSTATUS')}</option>
                      {paymentOptions.map((payment_status) => (
                        <option
                          key={payment_status.id}
                          value={payment_status.name}
                        >
                          {payment_status.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('PAYMENTSTATUS')}</label>
                  </div>
                </div>
                {/* Payment Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                    />
                    <label>{t('PAYMENTDATE')}</label>
                  </div>
                </div>
                {/* Order Remark */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={orderRemark}
                      onChange={(e) => setOrderRemark(e.target.value)}
                    />
                    <label>{t('ORDERREMARK')}</label>
                  </div>
                </div>
              </div>
            </div>
            {/* Products Section */}
            <section className="products-section">
              <h5>{t('PRODUCTSINFO')}</h5>
              <button className="btn btn-success" onClick={addProduct}>
                {t('ADDPRODUCT')}
              </button>
              <div
                className={`table-outer ${products.length > 0 ? 'scroll' : ''}`}
              >
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="id">
                        <h5>#</h5>
                      </th>
                      <th className="code">
                        <h5>{t('PRODUCTCODE')}</h5>
                      </th>
                      <th className="name">
                        <h5>{t('PRODUCTNAME')}</h5>
                      </th>
                      <th className="origin">
                        <h5>{t('ORIGIN')}</h5>
                      </th>
                      <th className="specification">
                        <h5>{t('SPECIFICATION')}</h5>
                      </th>
                      <th className="quantity">
                        <h5>{t('QUANTITY')}</h5>
                      </th>
                      <th className="remark">
                        <h5>{t('PRODUCTREMARK')}</h5>
                      </th>
                      <th className="location">
                        <h5>{t('PROCESSLOCATION')}</h5>
                      </th>
                      <th className="action">
                        {' '}
                        <h5>{t('ACTION')}</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr key={index} className={``}>
                        <td className="id">{index + 1}</td>
                        <td className="code">
                          {/* <Select
                            className=""
                            name="productCode"
                            value={
                              product.productId
                                ? {
                                    value: product.productId,
                                    label: `${product.productCode} - ${product.productName}`,
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              handleProductChange(index, selectedOption)
                            } // Pass selectedOption directly
                            options={productInfo.map((product) => ({
                              value: product.id,
                              label: `${product.code} - ${product.name}`,
                            }))}
                            isDisabled={!product.isEditing}
                            placeholder={t('SEARCHANDSELECTPRODUCT')}
                            isSearchable
                            // onInputChange={handleProductSearchInputChange}
                            // onMenuScrollToBottom={
                            //   handleProductMenuScrollToBottom
                            // }
                            isLoading={productLoading}
                            loadingMessage={() => 'Loading more...'}
                            isClearable
                          /> */}
                          <AsyncPaginate
                            //
                            value={
                              product.productId
                                ? {
                                    value: product.productId,
                                    label: `${product.productCode} - ${product.productName}`,
                                  }
                                : null
                            }
                            loadOptions={productsLoadOptions}
                            onChange={(selectedOption) =>
                              handleProductChange(index, selectedOption)
                            }
                            placeholder={t('SEARCHANDSELECTPRODUCT')}
                            isDisabled={!product.isEditing}
                            isClearable
                            additional={{
                              page: 1,
                            }}
                          />
                        </td>
                        <td className="name">
                          <input
                            type="text"
                            name="productName"
                            value={product.productName}
                            onChange={(e) => handleProductChange(index, e)}
                            ref={(el) =>
                              (dynamicSizeInputRefs.current[index] = el)
                            }
                            disabled
                          />
                        </td>
                        <td className="origin">
                          <input
                            type="text"
                            name="origin"
                            value={product.origin}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="specification">
                          <input
                            type="text"
                            name="specification"
                            value={product.specification}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                            ref={(el) =>
                              (specificationInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="quantity">
                          <input
                            type="number"
                            name="quantity"
                            value={trimDecimalZero(product.quantity)}
                            onChange={(e) => handleProductChange(index, e)}
                          />
                        </td>

                        <td className="remark">
                          <input
                            type="text"
                            name="productRemark"
                            value={product.productRemark}
                            onChange={(e) => handleProductChange(index, e)}
                            ref={(el) =>
                              (productRemarkInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="location">
                          <input
                            type="text"
                            name="processLocation"
                            value={product.processLocation}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="action">
                          <div className="d-flex gap-1">
                            {actionType === 'Edit' && (
                              <button
                                className="btn btn-primary"
                                onClick={() => toggleEdit(index)}
                              >
                                <img src="images/green-edit.svg" alt="Edit" />
                              </button>
                            )}
                            <button
                              className="btn btn-danger"
                              onClick={() => removeProduct(index)}
                            >
                              <img src="images/red-delete.svg" alt="" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => setEditCateringModal(false)}
                disabled={loader}
              >
                {t('CANCEL')}
              </button>
              <button
                className="save"
                onClick={() => saveSubmit()}
                disabled={loader}
              >
                {loader && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                )}
                {t('SAVE')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={confirmationModal}
        onRequestClose={() => setConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add `}
        portalClassName="add view-modal cutoff"
      >
        <ConfirmationModal
          type={'catering'}
          setConfirmationModal={setConfirmationModal}
          selectedOrdersEdit={selectedOrdersEdit}
          actionType={'Add'}
          onSuccess={handleModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default EditCateringModal;
